export { CardWithImage } from './card-with-image';
export type { CardWithImageProps } from './card-with-image';
